import {NgModule} from '@angular/core';
import {LanguageComponent} from './language.component';
import {CommonModule} from '@angular/common';
import {LanguageService} from './language.service';

@NgModule({
  imports: [CommonModule],
  declarations: [LanguageComponent],
  providers: [LanguageService],
  exports: [LanguageComponent],
})
export class LanguageModule {}
